module.exports = {
	"API_URL": "https://testapi.konsultacjejst.pl",
	"AUTH_STATE_ITEM_NAME": "konsultacje_forms_auth_state_test",
	"BUDGET_AUTH_STATE_ITEM_NAME": "konsultacje_budget_forms_auth_state_test",
	"GOOGLE_MAPS_API_KEY": "AIzaSyAUDGJ77tLHxjpToVwHQOcz1hQTxgzDi4c"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.test.json
// module id = 1421
// module chunks = 0